import React from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { AuthProvider } from "./context";
import { BrowserRouter as Router } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import AppRouter from "./router";
import "react-loading-skeleton/dist/skeleton.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLoadScript } from "@react-google-maps/api";
import Loader from "./components/Loader/index";
import ConsentBanner from "./ConsentBanner";
const libraries = ["places"];

const App = () => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries,
  });

  if (loadError) return <div>Error loading Google Maps</div>;
  if (!isLoaded) return <Loader />;
  return (
    <Provider store={store}>
      <AuthProvider>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          <Router>
            <AppRouter />
            <ToastContainer autoClose={4000} hideProgressBar={true} />
            <ConsentBanner />
          </Router>
        </GoogleOAuthProvider>
      </AuthProvider>
    </Provider>
  );
};

export default App;
